export function diasUteisNoMes(mes, ano, diasSemana) {
  const permitidos = new Set((diasSemana || '1,2,3,4,5').split(',').filter(Boolean).map(Number));
  const totalDias = new Date(ano, mes, 0).getDate();
  let count = 0;
  for (let d = 1; d <= totalDias; d++) {
    if (permitidos.has(new Date(ano, mes - 1, d).getDay())) count++;
  }
  return count;
}
